export const NETATMO_LEGACY_PRODUCT_ID = 'smartmixin.netatmo_weather.unlocker';

export const ANNUAL_SUBSCRIPTION_PRODUCT_ID = 'smartmixin.premium.annual';
export const MONTHLY_SUBSCRIPTION_PRODUCT_ID = 'smartmixin.premium.monthly';

export const FREEMIUM = 0;
export const PREMIUM = 1;
export const LEGACY_PREMIUM = 2;
export const PREMIUM_FREE = 3;
